import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Element } from "react-scroll";
import BreadcrumbsComponent from "../../Components/BreadCrumbs";
import LeftSideNav from "../../Components/LeftSideNav";
import TopNavBar from "../../Components/TopNavbar";
import Strings from "../../Config/Strings";
import {
  brandHeaderData,
  brandNameData,
  clientHeaderData,
  stateColumn,
  trendingItemColumn,
  trendingItemsData,
} from "../../Constants/MockData";
import { getDashboardDetailsAPI } from "../../Store/Action/dashboardAction";
import Colors from "../../theme/Colors";
import StateItemTable from "./Component/stateItemTable";
import CustomTable from "./CustomTable";
import TopCardSection from "./CardSection/TopCard";
import Icons from "../../Config/Images";
import Fonts from "../../Config/Fonts";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);
  const { userData } = useSelector((state) => state.user);

  const dashboardTopData = dashboardData?.[0];

  const dashboardState = dashboardTopData?.top_sales_by_state?.map(
    (stateData) => {
      return stateData;
    }
  );

  useEffect(() => {
    setBreadcrumbs([{ key: "1", href: "/dashboard", text: "Dashboard" }]);

    dispatch(
      getDashboardDetailsAPI({}, (result) => {
        setDashboardData(result);
      })
    );
  }, [dispatch]);

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />

      <div style={topContainerStyle} >
        <TopNavBar
          leftSideText={`Hello ${userData?.data?.[0]?.user_first_name}`}
          isDashboard={true}
        />
        <BreadcrumbsComponent breadcrumbs={breadcrumbs} />

        <div style={scrollContainerStyle}>
          <Element name="section1" style={sectionStyle}>
            <div style={cardRowStyle}>
              <TopCardSection
                cardTopText={Strings.totalGoldSale}
                cardValue={dashboardTopData?.total_gold_sales || 0}
                icons={Icons.totalGoldSaleIcon}
              />
              <TopCardSection
                cardTopText={Strings.totalSilverSale}
                cardValue={dashboardTopData?.total_sliver_sales || 0}
                icons={Icons.totalSliverSaleIcon}
              />
              <TopCardSection
                cardTopText={Strings.totalSalePcsRate}
                cardValue={dashboardTopData?.total_sales_pcs_rate || 0}
                icons={Icons.totalSalePcsRateIcon}
              />
              <TopCardSection
                cardTopText={Strings.productSold}
                cardValue={dashboardTopData?.product_sold || 0}
                icons={Icons.productSoldIcon}
              />
              <TopCardSection
                cardTopText={Strings.totalOrder}
                cardValue={dashboardTopData?.total_order || 0}
                icons={Icons.totalOrderIcon}
              />
              <TopCardSection
                cardTopText={Strings.newLogin}
                cardValue={0}
                icons={Icons.newLoginIcon}
              />
            </div>
            <div style={cardRowStyle}>
              <TopCardSection
                cardTopText={Strings.completeOrder}
                cardValue={dashboardTopData?.complete_order || 0}
                icons={Icons.completeOrderIcon}
              />
              <TopCardSection
                cardTopText={Strings.pendingOrder}
                cardValue={dashboardTopData?.pending_order || 0}
                icons={Icons.pendingOrderIcon}
              />
              <TopCardSection
                cardTopText={Strings.orderPipeline}
                cardValue={dashboardTopData?.order_pipeline || 0}
                icons={Icons.orderPipelineIcon}
              />
              <TopCardSection
                cardTopText={Strings.newCustomers}
                cardValue={dashboardTopData?.new_customers || 0}
                icons={Icons.newCustomerIcon}
              />
              <TopCardSection
                cardTopText={Strings.repeatCustomers}
                cardValue={dashboardTopData?.repeat_customers || 0}
                icons={Icons.repeatCustomerIcon}
              />
              <TopCardSection
                cardTopText={Strings.newSubscribe}
                cardValue={0}
                icons={Icons.newSubscribeIcon}
              />
            </div>
          </Element>

          <div style={bottomSectionMainView}>
            <Element name="section2" style={stateTableContainer}>
              <StateItemTable
                tableBodyData={dashboardState}
                tableHeaderData={stateColumn}
                mainHeadingText={"Sales By State"}
              />
            </Element>

            <Element name="section3" style={sellerTableContainer}>
              <StateItemTable
                tableBodyData={trendingItemsData}
                tableHeaderData={trendingItemColumn}
                mainHeadingText={"Best Sellers"}
              />
            </Element>

            <Element name="section4" style={horizontalSectionStyle}>
              <div style={section4TableContainerStyle}>
                <CustomTable
                  mainHeadingText={"Top Brands"}
                  tableData={brandNameData}
                  tableHeaderData={brandHeaderData}
                />
                <CustomTable
                  mainHeadingText={"Top Clients"}
                  tableData={brandNameData}
                  tableHeaderData={clientHeaderData}
                />
              </div>
            </Element>
          </div>
        </div>
      </div>
    </div>
  );
};

const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  backgroundColor: Colors.bgColor,
};

const topContainerStyle = {
  backgroundColor: Colors.bgColor,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  // marginLeft:"-6rem",

};

const scrollContainerStyle = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  paddingLeft: "20px",
};

const bottomSectionMainView = {
  display: "flex",
  flexDirection: "row",
  width: "98%",
  height: "100%",
  marginLeft: "6px",
};

const horizontalSectionStyle = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
};

const stateTableContainer = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  marginRight: "18px",
};

const sellerTableContainer = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  marginRight: "18px",
};

const section4TableContainerStyle = {
  display: "flex",
  flexDirection: "column", // Align tables side by side
  height: "100%",
};

const sectionStyle = {
  marginTop: "15px",
};

const cardRowStyle = {
  display: "flex",
  flexWrap: "wrap", // To handle responsive layouts
};

const headingTxtStyle = {
  fontSize: 24,
  fontWeight: "600",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
};

const waveIconStyle = {
  height: 30,
  width: 30,
  marginLeft: 8,
};

export default Dashboard;
